import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { logout } from '../action/logout-action';

interface CertificationInfoState {
  userAvatar?: string;
  endDate?: string;
  certificateForms: Array<{
    id: string;
    formData: {
      id: string | undefined;
      certificateName: string;
      institution: string;
      startDate: string;
      endDate: string;
      imageLink: string;
      country: string;
      studyField: any;
      gradePercentage: string;
    };
    imageUrl: string | null;
  }>;
}

const initialState: CertificationInfoState = {
  userAvatar: '',
  endDate: '',
  certificateForms: [],
};

const certificationInfoSlice = createSlice({
  name: 'certificationInfo',
  initialState,
  reducers: {
    setCertificationInfo: (state, action: PayloadAction<CertificationInfoState>) => {
      return { ...state, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  },
});

export const { setCertificationInfo } = certificationInfoSlice.actions;
export default certificationInfoSlice.reducer;
